import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpStatusCode,
} from '@angular/common/http'
import { catchError, concatMap, EMPTY, from, map, Observable, of, throwError } from 'rxjs'
import { Router } from '@angular/router'
import { AuthService } from './auth.service'
import { Injectable, inject } from '@angular/core'
import { environment } from '@environments/environment'

enum Urls {
  'current' = '/api/v1/loan-flow/loans/current',
  'dashboardLogin' = '/dashboard/login',
  'rejected' = '/decision-rejected',
  'trackData' = '/public/v1/track/data',
  'trackNavigation' = '/public/v1/track/navigation',
}

@Injectable({
  providedIn: 'root',
})
export class ApiInterceptor implements HttpInterceptor {
  private router = inject(Router)
  private authService = inject(AuthService)

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      headers: req.headers
        .append('version', '3.0.0')
        .append('service-id', String(environment.serviceId))
        .append('source', environment.appHost),
    })

    const customer = this.authService.customer()
    if (req.url.startsWith('/api/')) {
      req = req.clone({ withCredentials: true })
      if (customer && (req.url.includes(Urls.trackNavigation) || req.url.includes(Urls.trackData))) {
        req = req.clone({ headers: req.headers.set('X-CUSTOMER', String(customer.id)) })
      }
    }
    return next.handle(req).pipe(
      concatMap(event => this.handleCurrentLoanRedirect(event, req.url)),
      catchError((error: HttpErrorResponse) => {
        const url = req.url
        if (url.includes(Urls.trackNavigation) || url.includes(Urls.trackData)) {
          return EMPTY
        }
        switch (error.status) {
          case HttpStatusCode.InternalServerError:
          case HttpStatusCode.ServiceUnavailable:
          case HttpStatusCode.BadRequest:
            break
          case HttpStatusCode.UnprocessableEntity:
            this.router.navigateByUrl('/error')
            break
          case HttpStatusCode.Forbidden:
          case HttpStatusCode.Unauthorized:
            this.authService.logout()
            this.router.navigateByUrl(Urls.dashboardLogin)
            return EMPTY
        }
        return throwError(() => error)
      }),
    )
  }

  private handleCurrentLoanRedirect(event: HttpEvent<unknown>, url: string): Observable<HttpEvent<unknown>> {
    if (!(event instanceof HttpResponse) || !url.includes(Urls.current)) {
      return of(event)
    }

    const loan = (event.body as { loan?: { state_declined?: number | string } } | null)?.loan
    if (loan && Number(loan.state_declined ?? 0) === 0) {
      return of(event)
    }

    return from(this.router.navigateByUrl(Urls.rejected)).pipe(map(() => event))
  }
}
